'use strict';
// import React, { Component } from 'react';
// import ReactDOM from "react-dom";

const eventBus = {
    on(event, callback) {
      document.addEventListener(event, (e) => callback(e.detail));
    },
    dispatch(event, data) {
      document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event, callback) {
      document.removeEventListener(event, callback);
    },
  };

  Array.prototype.equals = function(arr2) {
    return (
      this.length === arr2.length &&
      this.every((value, index) => value === arr2[index])
    );
  };


class ThemeMenu extends React.Component {     // instead of: ...extends React.Component
    
    
    
    constructor(props) {
        super(props);
        this.state = { 
            "themes":[] ,
            "activeThemes":[]
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleDisplayClick = this.handleDisplayClick.bind(this);
        
    }

    componentDidMount() {
        this.fetchMenuThemes();
    }

    fetchMenuThemes(){
        fetch( admin_objects.rest_url +'theme?per_page=100')
        .then(response => response.json())
        .then(myJSON => {
            let objLength = Object.keys(myJSON).length;
            let newState = this.state;
            newState["themes"][0]={"name":"Tous les projets" ,"slug":"all-projects", "id":0,"statut":this.state.activeThemes}
            for (let i = 0; i < objLength; i++) {
                let objKey = Object.values(myJSON)[i].id;
                let objValues = Object.values(myJSON)[i];
                let statut="";
                objValues.id == 0 ? statut="active":  statut="disabled";
                newState.themes[objKey] = {"name":objValues.name ,"slug":objValues.slug, "id":objValues.id,"statut":this.state.activeThemes};

            }
            this.setState(newState,()=>{
                document.querySelectorAll('.theme-btn[theme-id="0"]')[0].classList.add('active');
            });
      }).then(()=>
        this.updateProjects());
    }

    handleDisplayClick(e){
        this.updateProjects();        
        toggleMenu();
    }

    handleClick(e){
        if(e.target.classList.contains("theme-btn")){
            this.updateActiveThemes(e.target);
            ;
        }
    }

    render() {
        return (
            <><div className="themes-list">
            {this.state.themes && this.state.themes.map((theme, index) => (
                <Theme name={theme.name} key={theme.id}  theme_id={theme.id} onThemeChange={this.handleClick} statut={this.state.activeThemes}/>                
            ))}
            </div>
            <div className="theme-valid-wrapper" ><div className="theme-btn-wrapper" onClick={this.handleDisplayClick} ><span className="theme-btn">Afficher</span></div></div>
            </>
        );
    }

    updateActiveThemes(target){
        let {activeThemes} = this.state;
        target.classList.toggle("active")
        let activeBtn = Array.from(document.querySelectorAll(".theme-btn.active"));
        let activeThemesIds = activeBtn.map((elt)=> {return parseInt(elt.attributes['theme-id'].value)});
        if (target.attributes['theme-id'].value !=0){
            let elt = document.querySelectorAll('.theme-btn.active[theme-id="0"]');
            if (elt.length >0){elt[0].classList.remove('active');}
            activeThemes = Array.from(activeThemesIds);
        }else{
            activeThemes=activeThemes.filter(function(ele){ 
                return false; 
            });
            activeThemes.push(0);
            document.querySelectorAll(".theme-btn.active").forEach((el,key,parent) =>{if(el.attributes['theme-id'].value !=0) {el.classList.remove("active")}});
        }
        
        this.setState((state)=>{
            return {activeThemes}
        });
    }

    updateProjects(){
        eventBus.dispatch("updateThemes", this.state.activeThemes);
    }
}

function ThemeRow(props) {
    function handleClick(e){
        props.onThemeChange(e);
    }
    return <div className='themes-row' >{props.themes.map((theme, index) => (<Theme name={theme.name} key={theme.id}  theme_id={theme.id} onThemeChange={handleClick} statut={props.statut}/>))}</div>;
}

function Theme(props) {
    function handleClick(e){
        props.onThemeChange(e);
    }
    return <div className="theme-btn-wrapper" onClick={handleClick} ><span theme-id={props.theme_id} className="theme-btn">{props.name}</span></div>;
}


class Projects extends React.Component {

    constructor(props) {
        super(props);

        let defaultProjects =[];
        for (let i = 0; i<9; i++){
            defaultProjects.push({});
        }
    
        this.state = { "projects": defaultProjects,"loadedIdx":0,"defaultProjects":defaultProjects,"themes":[], currentPage:0 };
        this.onUpdateThemes = this.onUpdateThemes.bind(this);
        this.trackScrolling = this.trackScrolling.bind(this);
        
    }

    componentDidMount() {
        eventBus.on("updateThemes", this.onUpdateThemes);
        this.fetchProjects();
    }

    componentDidUpdate(pprops,pstate){
        if (!pstate.themes.equals(this.state.themes)){
            this.fetchProjects();
        }
    }

    onUpdateThemes(newThemes){
        let {currentPage} = this.state;
        currentPage = 0;
        let {loadedIdx} = this.state;
        loadedIdx = 0;
        let {themes} = this.state;
        themes.length = 0;
        themes = Array.from(newThemes);
        this.setState( {themes,loadedIdx,currentPage});
    }
    
    isBottom(el) {
        let elBottom = el.getBoundingClientRect().bottom;
        return elBottom <= window.innerHeight+1;
      }

    trackScrolling() {
        const wrappedElement = document.getElementById('colophon');
        if (this.isBottom(wrappedElement)) {
          this.fetchProjects();
          document.removeEventListener('scroll', this.trackScrolling);
        }
    };

    fetchProjects(){
        let themes=""
        if (this.state.themes.length == 0 || (this.state.themes.length ==1 && this.state.themes[0]==0)){themes="";}else{themes='&theme='+this.state.themes;}
        let requestedpage = this.state.currentPage + 1;
        document.getElementById('project-loader').classList.add("show");
        fetch( admin_objects.rest_url +'white_page_project?per_page='+this.props.perPages+themes+'&page='+requestedpage)
        .then(response => response.json())
        .then(myJSON => {
            let objLength = Object.keys(myJSON).length;
            let newState = this.state;
            for (let i = 0; i < objLength; i++) {
                let objValues = Object.values(myJSON)[i];
                newState.projects[newState.loadedIdx+i] = objValues;
            }
            newState.projects = newState.projects.filter((el,idx)=>
                {return el.hasOwnProperty("id") && idx < (newState.loadedIdx + objLength)})

            newState.loadedIdx += objLength;
            newState.currentPage++;
            this.setState(newState);
            if (this.props.perPages<=objLength){
                document.addEventListener('scroll', this.trackScrolling);
            }
            document.getElementById('project-loader').classList.remove("show");
            });
    }

    render(){
        return (
            <>
            {this.state.projects && this.state.projects.map(function(project, index) {
                let cmpIdx = index;
                if ( project.hasOwnProperty("id")){
                    cmpIdx = project.id
                }
                return (<Project key={cmpIdx } project={project} />)
            }                
            )}
        </>)
    }
}

class Project extends React.Component {
    constructor(props) {
        super(props);
        this.state = { "ContentLoaded": "loading", "ImgLoaded": "loading"};
        this.onLoaded = this.onLoaded.bind(this);
        
    }

    onLoaded(statut){
        let loaded="";
        statut ? loaded="": loaded="loading";
        this.setState((state) =>{ return {"ImgLoaded" : loaded}});
    }

    componentDidUpdate(){
        if(this.props.project.title && this.props.project['post-meta-fields']){
            this.setState((state)=>{this.state.ContentLoaded=""})
        }
    }

    render(){

        let {project}  = this.props;
        let widthIdx = 1, heightIdx = 2;
        let alt="",url="#", width = 300, height = 200;

        let containerWidth = window.innerWidth * .8333;

        let columnWidth = containerWidth;
        if ( (window.innerWidth < 992) && (window.innerWidth > 768) ) {
            columnWidth = containerWidth * .5;
        } 
        if ( window.innerWidth > 992 ) {
            columnWidth = ( containerWidth * .333 ) - 40 - 30;
        }
        width = Math.trunc( columnWidth ); 
        height = width *.67;


        if ( project._links && project._links["wp:featuredmedia"] && project._links["wp:featuredmedia"][0].href ){ url = project._links["wp:featuredmedia"][0].href}
        if ( project.hasOwnProperty('feature_media_meta') && false !== project.feature_media_meta ){ 
            
            height =  Math.trunc ( ( project.feature_media_meta[heightIdx] / project.feature_media_meta[widthIdx] ) * columnWidth ); 
        }
        if(project.title){ alt = project.title.rendered}
        let img = {
            url: url , 
            width: width, 
            height: height, 
            alt: alt
        };
        let title="";
        if (project.title){
            var textArea = document.createElement('textarea');
            textArea.innerHTML = project.title.rendered;
            title =  textArea.value;
        }

        return  (<div className="col-xs-12 col-md-6 col-lg-4 col-project" >
                <div className={`project ${this.state.ImgLoaded}`}>
                    <a href={project.link} className={this.state.ImgLoaded}>
                    <PrjImg img={img} onLoaded={this.onLoaded} />
                        <div className={`thumbnail-hover ${this.state.ContentLoaded}`}>
                            <div className="background"></div>
                            {project.title &&<h2 className="project-title">{title}</h2>}
                            {project['post-meta-fields'] && project['post-meta-fields'].year &&<div className ="project-year">{project['post-meta-fields'].year}</div>}
                        </div>
                        <div className="thumbnail-hover-mobile">
                            {project.title &&<div style={{clear:"both"}}><h2 className="project-title">{title}</h2></div>}
                            {project['post-meta-fields'] && project['post-meta-fields'].year &&<div style={{clear:"both"}}><div className ="project-year">{project['post-meta-fields'].year}</div></div>}
                        </div>
                        <div className="dummy-rise-border-bottom"></div>
                    </a>
                </div>
            </div>)
    }

}

class PrjImg extends React.Component{

    constructor(props) {
        super(props);
        this.state = { 
            "src": this.placeholderSrc(props.img),
            "alt": props.img.alt,
            "sizes": {all:{file:this.placeholderSrc(props.img), width: props.img.width}},
            "loaded": "not-loaded",
            "data": {}};        
    }

    componentDidMount() {
        this.fetchImage(this.props.img.url);
    }

    componentDidUpdate(prevProps, prevState){
        if ((prevProps.img.url != this.props.img.url ) && (this.state.loaded == "not-loaded")){
            this.fetchImage(this.props.img.url);
        }else{
            if ((this.props.img.url !="#") && (this.state.loaded == "loaded")){
                this.props.onLoaded(this.state.loaded );
                let newState = this.state;
                newState.loaded = "finished";
                this.setState(newState); 
            }
        }            
    }

    placeholderSrc(img) {
        let { width, height } = img;
        
        return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'%3E%3Cdefs%3E%3Cstyle%3E .b %7B fill: %23ddd; %7D %3C/style%3E%3C/defs%3E%3Crect class='b' width='${width}' height='${height}'/%3E%3C/svg%3E`;
    }


    fetchImage(url){
        if (url !="#" && this.state.loaded=="not-loaded"){
            let newState = this.state;
            newState.loaded = "pending";
            newState.src = this.placeholderSrc(this.props.img),
            this.setState(newState);           
            fetch( url)
            .then(response => response.json())
            .then(myJSON => {
                let newState    = this.state;
                newState.data   = myJSON;
                newState.src    = myJSON.source_url;
                newState.sizes  = myJSON.media_details.sizes;
                newState.alt    = myJSON.alt_text !="" ? myJSON.alt_text: this.state.alt;
                newState.loaded = "fetched";
                this.setState(newState);
            });

        }
    }

    handleImageLoaded(){
        if ( ! this.state.src.startsWith("data:image") ){
            let newState    = this.state;
            newState.loaded = "loaded";
            this.setState(newState);
        }
    }

    render(){
        let srcsetAttr = '';
        if ( !( ( '#' === this.props.img.url) || ( this.state.loaded === "pending" ) || ( this.state.loaded === "not-loaded" ) ) ) {
            let srcsetArr = Object.values(this.state.sizes).map(function(elt){
                return `${elt.source_url} ${elt.width}w`;
            },"");
            srcsetAttr = srcsetArr.join(",");
        }
        return (<img className="prj-image" src={this.state.src} alt={this.state.alt} height={this.props.img.height} width={this.props.img.width} srcset={srcsetAttr} sizes=" ( min-width:992px ) 27vw, (min-width:768px ) 41.6vw, 100vw" onLoad={this.handleImageLoaded.bind(this)}/>);
    }
}

window.addEventListener('load', () => {	
    // Render the app inside our shortcode's #app div
    ReactDOM.render(
        <ThemeMenu />,
        document.getElementById('menu-projets'));

    if (document.getElementById('projects') !=null){
        let perPages=9;
        ReactDOM.render(
            <Projects perPages={perPages} />,
            document.getElementById('projects'));
    }

});